import { api } from './axios';
import type {
  IndividualRankingItem,
  TeamSumRankingItem,
  SaveIndividualResultDto,
} from '../types/domain';

export const individualResultsApi = {
  saveResult: (disciplineId: number, dto: SaveIndividualResultDto) =>
    api.post(`/recorder/disciplines/${disciplineId}/individual-results`, dto)
       .then((r) => r.data),

  registerFalseStart: (disciplineId: number, athleteId: number) =>
    api.post(
      `/recorder/disciplines/${disciplineId}/athletes/${athleteId}/false-start`
    ).then((r) => r.data),

  getIndividualRanking: (disciplineId: number) =>
    api.get<IndividualRankingItem[]>(
      `/public/disciplines/${disciplineId}/individual-ranking`
    ).then((r) => r.data),

  getTeamSumRanking: (disciplineId: number) =>
    api.get<TeamSumRankingItem[]>(
      `/public/disciplines/${disciplineId}/team-sum-ranking`
    ).then((r) => r.data),
};
